import * as shootingsEvents from '@/mixins/analitycs/shootingsEvents'
import * as liveEvents from '@/mixins/analitycs/liveEvents'

export default function (multianalytics) {
  return {
    connection(userId) {
      multianalytics.identify(shootingsEvents.connection(userId))
    },
    shootingsSearch() {
      multianalytics.trackEvent(shootingsEvents.shootingsSearch)
    },
    shootingsSearchReset() {
      multianalytics.trackEvent(shootingsEvents.shootingsSearchReset)
    },
    shootingsSeeMore() {
      multianalytics.trackEvent(shootingsEvents.shootingsSeeMore)
    },
    shootingsAdd() {
      multianalytics.trackEvent(shootingsEvents.shootingsAdd)
    },
    shootingsDownload(type) {
      if (type === 'ORIGINAL') {
        multianalytics.trackEvent(shootingsEvents.shootingsDownloadOriginal)
      } else if (type === 'STAMPED') {
        multianalytics.trackEvent(shootingsEvents.shootingsDownloadStamped)
      } else return
    },
    shootingsViewShooting(typeOfView) {
      typeOfView
        ? multianalytics.trackEvent(shootingsEvents.shootingsViewShootingDetailed)
        : multianalytics.trackEvent(shootingsEvents.shootingsViewShootingSimple)
    },
    shootingsReplayDms() {
      multianalytics.trackEvent(shootingsEvents.shootingsReplayDms)
    },
    shootingsWebinaireRedirect() {
      multianalytics.trackEvent(shootingsEvents.shootingsWebinaireRedirect)
    },
    shootingsDisplayPlayer() {
      multianalytics.trackEvent(shootingsEvents.shootingsDisplayPlayer)
    },
    shootingsSendPlayer() {
      multianalytics.trackEvent(shootingsEvents.shootingsSendPlayer)
    },
    liveCreateRoom() {
      multianalytics.trackEvent(liveEvents.liveCreateRoom)
    },
    liveCopy(copyFrom) {
      if (copyFrom === 'RoomLive') {
        multianalytics.trackEvent(liveEvents.liveCopyFromRoomList)
      } else if (copyFrom === 'Live') {
        multianalytics.trackEvent(liveEvents.liveCopyFromLive)
      } else if (copyFrom === 'ChangeNavigatorAlert') {
        multianalytics.trackEvent(liveEvents.liveCopyChangeNavigatorAlert)
      } else return
    },
    sendEmail(sendFrom) {
      if (sendFrom === 'Player') {
        multianalytics.trackEvent(shootingsEvents.shootingsSendPlayer)
      } else if (sendFrom === 'LiveRooms') {
        multianalytics.trackEvent(liveEvents.liveSendFromRoomList)
      } else if (sendFrom === 'Live') {
        multianalytics.trackEvent(liveEvents.liveSendFromLive)
      } else;
    },
    liveRoomConnection() {
      multianalytics.trackEvent(liveEvents.liveRoomConnection)
    },
    liveBackToRooms() {
      multianalytics.trackEvent(liveEvents.liveBackToRooms)
    },
    liveBackToLive() {
      multianalytics.trackEvent(liveEvents.liveBackToLive)
    },
    liveShareScreen() {
      multianalytics.trackEvent(liveEvents.liveShareScreen)
    }
  }
}
